import { render, staticRenderFns } from "./ResearchField.vue?vue&type=template&id=3da83c86&scoped=true&"
import script from "./ResearchField.vue?vue&type=script&lang=js&"
export * from "./ResearchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da83c86",
  null
  
)

export default component.exports